<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <v-row>
        <v-col cols="6">

         <ValidationProvider
              rules="required"
              vid="date"
              :name="$t('fields.date').toLowerCase()"
              v-slot="{ errors }"
          >
            <InputDataPicker
              v-model="form.date"
              :label="$t('fields.date')"
              :clearable="true"
              :error-messages="errors"
            />
          </ValidationProvider>
          <ValidationProvider
              rules="required"
              vid="causal"
              :name="$t('fields.causal').toLowerCase()"
              v-slot="{ errors }"
          >
            <v-text-field
              v-model=" form.causal"
              :counter="30"
              :label="$t('fields.causal')"
              :error-messages="errors"
            ></v-text-field>

          </ValidationProvider>
          <ValidationProvider
                rules="required"
                vid="recipient"
                :name="$t('fields.recipient').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model="form.recipient"
                :counter="30"
                :label="$t('fields.recipient')"
                :error-messages="errors"
              ></v-text-field>

          </ValidationProvider>
          <ValidationProvider
              rules="required"
              vid="address"
              :name="$t('fields.address').toLowerCase()"
              v-slot="{ errors }"
          >
            <v-text-field
              v-model=" form.address"
              :counter="30"
              :label="$t('fields.address')"
              :error-messages="errors"
            ></v-text-field>

          </ValidationProvider>
        </v-col>

        <v-col cols="6">
          <ValidationProvider
              rules="required"
              vid="city"
              :name="$t('fields.city').toLowerCase()"
              v-slot="{ errors }"
          >
            <v-text-field
              class="mt-7"
              v-model=" form.city"
              :counter="30"
              :label="$t('fields.city')"
              :error-messages="errors"
            ></v-text-field>

          </ValidationProvider>
          <ValidationProvider
                rules="required"
                vid="zip"
                :name="$t('fields.zipcode').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.zip"
                :counter="30"
                :label="$t('fields.zipcode')"
                :error-messages="errors"
              ></v-text-field>

          </ValidationProvider>

          <ValidationProvider
                rules="required"
                vid="package"
                :name="$t('fields.package').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.package"
                :counter="30"
                :label="$t('fields.package')"
                :error-messages="errors"
              ></v-text-field>

          </ValidationProvider>

          <ValidationProvider
                rules="required"
                vid="weight"
                :name="$t('fields.weight').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.weight"
                :counter="30"
                :label="$t('fields.weight')"
                :error-messages="errors"
              ></v-text-field>

          </ValidationProvider>
        </v-col>
      </v-row>
      <BookSelection
        v-model="bookSelected"
      >
      </BookSelection>
      <v-simple-table
                  fixed-header
                  height="600px"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          {{$t('fields.isbn')}}
                        </th>
                        <th class="text-left">
                          {{$t('fields.book')}}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in bookSelected"
                        :key="item.id"
                      >
                        <td>{{ item.isbn }}</td>
                        <td>{{ item.title }} {{ item.volume }}</td>
                        <td>
                          <v-layout row wrap>
                            <v-flex>
                              <v-text-field
                                v-model="form.qtySelected[item.isbn]"
                                :counter="30"
                                :error-messages="errors"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import BookSelection from '../../app/Books/BookSelection.vue';
  import InputDataPicker from '../../shared/Inputs/InputDataPicker.vue';

  export default {
    name: 'WarehouseUnloadModal',
    components: {
      InputDataPicker,
      BookSelection,
    },
    data() {
      return {
        stored: null,
        form: {
          date: null,
          causal: null,
          recipient: null,
          address: null,
          zip: null,
          city: null,
          package: null,
          weight: null,
          qtySelected: {},
        },
        bookSelected: [],
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      getActiveIDs() {
        return this.bookSelected.map(x => x.isbn);
      },

      getQtySelected() {
        if (this.qtySelected !== undefined) {
          Object.keys(this.form.qtySelected).forEach(element => {
            if (!this.getActiveIDs.includes(Number(element))) {
              delete this.form.qtySelected[element];
            }
          });

          return this.qtySelected;
        }

        return {};
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
  };
</script>
